import { observer } from "mobx-react-lite"

import { ComplexTabsList } from "@/domains/common/components/complex-tabs-list"

import { CLASSIC_LIQUIDITY_TABS } from "../constants"

export const LiquidityPageTabs = observer(() => {
  return <ComplexTabsList tabs={CLASSIC_LIQUIDITY_TABS} />
})
